import devapis from "./devapis";
import stagingapis from "./stagingapis";
import prodapis from "./prodapis";

export const config = {
  dev: {
    base: "http://localhost:3000,http://localhost:3001,https://devpractiko.cognospace.in/open/login",
    api_base: "https://devapi.cognospace.in",
    static_token: "",
    ...devapis,
    "open/login": {
      base: "http://localhost:3000,http://localhost:3001,https://devpractiko.cognospace.in/open/login",
      api_base: "https://devapi.cognospace.in",
      ...devapis,
    },
  },
  staging: {
    base: "https://stagepractiko.cognospace.in",
    api_base: "https://stageapi.cognospace.in",
    static_token: "",
    ...stagingapis,

    "open/login": {
      base: "https://stagepractiko.cognospace.in",
      api_base: "https://stageapi.cognospace.in",
      ...stagingapis,
    },
  },
  production: {
    base: "https://practiko.cognospace.in",
    api_base: "https://api.cognospace.in",
    static_token: "",
    ...stagingapis,

    "open/login": {
      base: "https://practiko.cognospace.in",
      api_base: "https://api.cognospace.in",
      ...stagingapis,
    },
  },
};

export default config;
